"use strict";

module.exports = {
  'border-default-s': '1px solid #B3B3B3',
  'border-default-l': '2px solid #B3B3B3',
  'border-radius-s': '4px',
  'border-radius-l': '8px'
};